import {HttpClient} from '@angular/common/http';
import 'rxjs/add/operator/catch';
import {Injectable} from '@angular/core';
import {ApiEndpoints} from '../ApiEndpoints';
import {ApiUtils} from '../ApiUtils';
import 'rxjs/add/operator/map';
import { plainToClass } from 'class-transformer';
import { SharedMethods } from '../../../../util/sharedMethods-service';
import { Paiement } from '../../model/paiement';



@Injectable()
export class PaiementService {


  iSconnecting: boolean = false;

  paiements: Paiement[];

  constructor(public apiEndpoints: ApiEndpoints, public http: HttpClient,
              public apiUtils: ApiUtils,
              // public networkService:NetworkService,
              // public sharedMethods: SharedMethods
              public sharedMethods: SharedMethods,
              ) { }

  getPaiements() {
    this.iSconnecting = true;
    return new Promise<Paiement[]>(resolve => {
      this.http.get(this.apiEndpoints.URL_GET_PAIEMENT,
        {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
        .subscribe((data: Paiement[]) => {
            const devices = plainToClass(Paiement, data);
            this.paiements = devices;
            resolve(devices);
            this.iSconnecting = false;
          },
          err => {
            // console.log(err);
            this.sharedMethods.errorApiShow(err.error.code, err.error.message);
            this.iSconnecting = false;
        });
    });
  }

  save(paiement: Paiement) {

      const dev = {
          /* firebaseToken: device.firebase_token,
          browser: device.browser,
          browserVersion: device.browser_version,
          os: device.os,
          osVersion: device.os_version,
          type: device.type,
          lang: device.lang,
          countryCode: device.country_code,
          countryName: device.country_name,
          latitude: device.latitude,
          longitude: device.longitude,
          city: device.city,
          ipv4: device.ipv4, */
      };
      

      return new Promise<Paiement>(resolve => {
        this.http.patch(this.apiEndpoints.GET_URL_PATCH_PAIEMENT_ADMIN(paiement.id), dev,
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe((data: Paiement) => {
              /* resolve(data);
              this.iSsaving = false; */
              resolve(data);
            },
            err => {
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              // alert(JSON.stringify(err));
              //this.iSsaving = false;
            });
      });


  }

  deleteDevice(paiement: Paiement) {

    this.iSconnecting = true;
  
    return new Promise(resolve => {
      this.http.delete(this.apiEndpoints.GET_URL_DELETE_PAIEMENT(paiement.id),
        {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
        .subscribe(data => {

            resolve(data);
            this.iSconnecting = false;

          },
          err => {
            this.sharedMethods.errorApiShow(err.error.code, err.error.message);
            // alert(JSON.stringify(err));
            this.iSconnecting = false;
        });
    });

  }


  validatePay(idpaiement) {

    return new Promise<any>(resolve => {
      this.http.get(this.apiEndpoints.URL_GET_VALIDATEPAIEMENT(idpaiement),
        {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
        .subscribe((data: any) => {
            
            resolve(data);
            this.iSconnecting = false;

          },
          err => {

            // console.log(err);
            this.sharedMethods.errorApiShow(err.error.code, err.error.message);
            this.iSconnecting = false;

        });
    });

  }

}
